import React from 'react';
import {
  FaFileSignature,
  FaBriefcase,
  FaCloud,
  FaBookOpen,
} from 'react-icons/fa';
import {
  FeatureStrip,
  FeatureStripItem,
  FeatureStripIcon,
} from './Features.styles';

const Features = () => {
  return (
    <FeatureStrip>
      <FeatureStripItem>
        <FeatureStripIcon>
          <FaFileSignature />
        </FeatureStripIcon>

        <div>
          <strong>Custom Development</strong>
          <span>Built around your workplace and operations.</span>
        </div>
      </FeatureStripItem>

      <FeatureStripItem>
        <FeatureStripIcon>
          <FaBriefcase />
        </FeatureStripIcon>

        <div>
          <strong>Workplace Focused</strong>
          <span>Documentation designed for real business needs.</span>
        </div>
      </FeatureStripItem>

      <FeatureStripItem>
        <FeatureStripIcon>
          <FaCloud />
        </FeatureStripIcon>

        <div>
          <strong>Online Access</strong>
          <span>Make manuals available through your company account.</span>
        </div>
      </FeatureStripItem>

      <FeatureStripItem>
        <FeatureStripIcon>
          <FaBookOpen />
        </FeatureStripIcon>

        <div>
          <strong>Easy to Reference</strong>
          <span>
            Give employees a central place to find safety information.
          </span>
        </div>
      </FeatureStripItem>
    </FeatureStrip>
  );
};

export default Features;
